import _ from "underscore"

const filterProducts = (products, sort) => {
  const mapArray = [...products]
  const sortType = sortBy => {
    switch (sortBy) {
      case "all":
        return mapArray
      case "price-ascending":
        const sortedAscArray = mapArray.sort(function (a, b) {
          return (
            parseFloat(a.contextualPricing.minVariantPricing.price.amount) -
            parseFloat(b.contextualPricing.minVariantPricing.price.amount)
          )
        })
        return sortedAscArray
      case "price-descending":
        const sortedDescArray = mapArray.sort(function (a, b) {
          return (
            parseFloat(b.contextualPricing.minVariantPricing.price.amount) -
            parseFloat(a.contextualPricing.minVariantPricing.price.amount)
          )
        })
        return sortedDescArray
      case "title-a-z":
        const sortedAlphabetArray = _.sortBy(mapArray, function (i) {
          return i.title.toLowerCase()
        })

        return sortedAlphabetArray
      case "title-z-a":
        const sortedDescAlphabetArray = _.sortBy(mapArray, function (i) {
          return i.title.toLowerCase()
        })
        sortedDescAlphabetArray.reverse()

        return sortedDescAlphabetArray
      default:
        return mapArray
    }
  }
  const sortedArray = sortType(sort)

  return sortedArray
}

export { filterProducts }
